// import React, { useEffect, useRef, useState } from "react";
// import { toast } from "react-toastify";
// import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

// import useApiRequest from "../../../../Hooks/apiReq";
// import TitleSection from "../../../../Shared/TitleSection/TitleSection";

// import Loader from "../../../../CommonComponets/Loader";

// import { convertToINRFormat } from "../../../../Utils/INRConvert";
// import moment from "moment";
// import BackButton from "../../../../Shared/BackButton";
// const MyPayoutDetailOrg = () => {
//   const [preFilter, setPreFilter] = useState({});
// const [response, setResponse] = useState({
//   AssociateName: "John Doe",
//   AssociateCode: "ASSO12345",
//   Rank: "Platinum Director",
//   PayoutNo: "PAY-2026-001",
//   ClosingDate: "31-Jan-2026",
//   TotalSelfBussiness: 150000,
//   TotalSelfIncome: 12500,
//   TotalTeamBussiness: 1200000,
//   TotalTeamIncome: 48000,
//   AssoSelfBPayoutDetailListData: [
//     {
//       PaidAmount: 50000,
//       AssoName: "John Doe",
//       CustomerName: "Alice Smith",
//       PaymentDate: "12-Jan-2026",
//       DirectPVAmount: 500,
//       LevelPVAmount: 200,
//       DirectPVPercentage: 10,
//       LevelPVPercentage: 5,
//       PlotNo: "B-402",
//       JSONDetailsSelfData: [
//         {
//           BusinessAmount: 50000,
//           IncomeAmount: 5000,
//           IncomeType: "SBC",
//           PVPercent: 10,
//           PVValue: 500,
//           SBCPercent: "10",
//           TBCPercent: "0",
//           Rank: "Platinum",
//         },
//       ],
//     },
//   ],
//   AssoTeamBPayoutDetailListData: [
//     {
//       PaidAmount: 120000,
//       AssoName: "Robert Brown",
//       CustomerName: "Charlie Davis",
//       PaymentDate: "15-Jan-2026",
//       DirectPVAmount: 1200,
//       LevelPVAmount: 600,
//       DirectPVPercentage: 12,
//       LevelPVPercentage: 6,
//       PlotNo: "A-101",
//       JSONDetailsTeamData: [
//         {
//           BusinessAmount: 120000,
//           IncomeAmount: 7200,
//           IncomeType: "TBC",
//           PVPercent: 12,
//           PVValue: 1440,
//           SBCPercent: "0",
//           TBCPercent: "6",
//           Rank: "Gold",
//         },
//       ],
//     },
//   ],
// });
//   // const { id } = useParams();
//   const { state } = useLocation();
//   const id = state?.payoutNo || "";
//   const { error, loading, recallRequest, sendApiRequest, status } =
//     useApiRequest();
//   const navigate = useNavigate();

//   const getPayoutDetails = (no) => {
//     if (loading) return;
//     if (true) {
//       var userData = {
//         PayoutNo: no,
//         DeviceType: "Web",
//       };
//       sendApiRequest("POST", "/GetAssociatePayoutDetail", userData, "", true);
//     }
//   };
//   useEffect(() => {
//     // getPayoutDetails(id);
//   }, []);
//   const handleClick = () => {
//     navigate(-1, { replace: true });
//   };
//   return (
//     <>
//       <div class="content">
//         <div class="container-fluid ">
//           <div class="row g-2 mx-1">
//             <div class="col-12">
//               <div className=" d-flex justify-content-between">
//                 <TitleSection text="My Payout detail" />
//                 <BackButton onClick={handleClick} />
//               </div>
//             </div>
//           </div>
//           {<PayoutSummaryCards response={response} />}
//           {<PayoutDetails loading={loading} response={response} />}
//         </div>
//         {loading && <Loader />}
//       </div>
//     </>
//   );
// };

// export default MyPayoutDetailOrg;
// const themeColor = "#7b3a00";
// const PayoutDetails = ({ response, loading }) => {
//   if (!response) {
//     return (
//       !loading && (
//         <div className="text-center p-5">
//           <h5 style={{ color: themeColor }}>No data found</h5>
//         </div>
//       )
//     );
//   }

//   const selfData = response.AssoSelfBPayoutDetailListData || [];
//   const teamData = response.AssoTeamBPayoutDetailListData || [];

//   return (
//     <div className="  py-4">
//       {/* SELF BUSINESS SECTION */}
//       <div className="card shadow mb-4 border-0 rounded-3">
//         <div className="card-body">
//           <h4
//             className="fw-bold mb-3 pb-2 border-bottom"
//             style={{ color: themeColor }}
//           >
//             Self Business Payout Details
//           </h4>
//           {selfData.length === 0 ? (
//             <p className="text-danger text-center fs-6">
//               No self business payout data available.
//             </p>
//           ) : (
//             selfData.map((payout, index) => (
//               <div key={index} className="mb-4">
//                 {/* General Info */}
//                 <div className="row mb-3">
//                   {index + 1}.
//                   <div className="col-md-6 ps-1">
//                     <strong>Business Amount: </strong>{" "}
//                     <span className="badge bg-org fw-bold">
//                       {convertToINRFormat(payout?.PaidAmount)}
//                     </span>
//                   </div>
//                   <div className="col-md-6 ">
//                     <strong>Business By: </strong>
//                     {payout?.AssoName ? payout?.AssoName : "---"}
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Customer:</strong>{" "}
//                     {payout?.CustomerName ? payout?.CustomerName : "----"}
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Business Date:</strong>
//                     <span className=""> {payout.PaymentDate}</span>
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Point Value (Direct / Level):</strong>{" "}
//                     {payout?.DirectPVAmount + "/" + payout?.LevelPVAmount}
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Point Value in Percent (Direct / Level):</strong>
//                     {payout?.DirectPVPercentage +
//                       "/" +
//                       payout?.LevelPVPercentage}
//                   </div>
//                   {/* <div className="col-md-6">
//                                         <strong>Payment Type:</strong>{" "}
//                                         <span className="badge bg-info">{payout.PaymentType}</span>
//                                     </div> */}
//                   {/* <div className="col-md-6">
//                                         <strong>Amount Type:</strong>{" "}
//                                         <span className="badge bg-dark">{payout.AmountType}</span>
//                                     </div> */}
//                   <div className="col-md-6">
//                     <strong>Plot No: </strong>
//                     <span className="badge bg-org">{payout.PlotNo}</span>
//                   </div>
//                 </div>

//                 {/* JSON Team Data Table */}
//                 <div className="table-responsive">
//                   <table className="table table-bordered table-hover text-white">
//                     <thead
//                       style={{ backgroundColor: themeColor, color: "#fff" }}
//                     >
//                       <tr>
//                         <th className=" text-white">Business Amount</th>
//                         <th className=" text-white">Income Amount</th>
//                         <th className=" text-white">Income Type</th>
//                         <th className=" text-white">PV %</th>
//                         <th className=" text-white">PV Value</th>
//                         <th className=" text-white">Commission %</th>
//                         <th className=" text-white">Rank</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {payout.JSONDetailsSelfData?.map((row, idx) => (
//                         <tr key={idx}>
//                           <td className="ps-2">
//                             {convertToINRFormat(row?.BusinessAmount)}
//                           </td>
//                           <td>{convertToINRFormat(row.IncomeAmount)}</td>
//                           <td>{row.IncomeType}</td>
//                           <td>{row.PVPercent}%</td>
//                           <td>{row.PVValue}</td>
//                           <td>
//                             {parseInt(row.SBCPercent) > 0
//                               ? parseInt(row.SBCPercent)
//                               : parseInt(row.TBCPercent)
//                                 ? parseInt(row.TBCPercent)
//                                 : 0}{" "}
//                             % {row?.IncomeType}
//                           </td>
//                           <td className="ps-2">{row.Rank}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>

//       {/* TEAM BUSINESS SECTION */}
//       <div className="card shadow mb-4 border-0 rounded-3">
//         <div className="card-body">
//           <h4
//             className="fw-bold mb-3 pb-2 border-bottom"
//             style={{ color: themeColor }}
//           >
//             Team Business Payout Details
//           </h4>
//           {teamData.length === 0 ? (
//             <p className="text-danger text-center fs-6">
//               No team business payout data available.
//             </p>
//           ) : (
//             teamData.map((payout, index) => (
//               <div key={index} className="mb-4">
//                 {/* General Info */}
//                 <div className="row mb-3">
//                   {index + 1}.
//                   <div className="col-md-6 ps-1">
//                     <strong>Business By: </strong>
//                     {payout?.AssoName ? payout?.AssoName : "---"}
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Customer:</strong>{" "}
//                     {payout?.CustomerName ? payout?.CustomerName : "----"}
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Business Date:</strong>
//                     <span className=""> {payout.PaymentDate}</span>
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Point Value (Direct / Level):</strong>{" "}
//                     {payout?.DirectPVAmount + "/" + payout?.LevelPVAmount}
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Point Value in Percent (Direct / Level):</strong>
//                     {payout?.DirectPVPercentage +
//                       "/" +
//                       payout?.LevelPVPercentage}
//                   </div>
//                   {/* <div className="col-md-6">
//                                         <strong>Payment Type:</strong>{" "}
//                                         <span className="badge bg-info">{payout.PaymentType}</span>
//                                     </div> */}
//                   {/* <div className="col-md-6">
//                                         <strong>Amount Type:</strong>{" "}
//                                         <span className="badge bg-dark">{payout.AmountType}</span>
//                                     </div> */}
//                   <div className="col-md-6">
//                     <strong>Business Amount: </strong>{" "}
//                     <span className="badge bg-org fw-bold">
//                       {convertToINRFormat(payout?.PaidAmount)}
//                     </span>
//                   </div>
//                   <div className="col-md-6">
//                     <strong>Plot No: </strong>
//                     <span className="badge bg-org">{payout.PlotNo}</span>
//                   </div>
//                 </div>

//                 {/* JSON Team Data Table */}
//                 <div className="table-responsive">
//                   <table className="table table-bordered table-hover text-white">
//                     <thead
//                       style={{ backgroundColor: themeColor, color: "#fff" }}
//                     >
//                       <tr>
//                         <th className=" text-white">Business Amount</th>
//                         <th className=" text-white">Income Amount</th>
//                         <th className=" text-white">Income Type</th>
//                         <th className=" text-white">PV %</th>
//                         <th className=" text-white">PV Value</th>
//                         <th className=" text-white">Commission %</th>
//                         <th className=" text-white">Rank</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {payout.JSONDetailsTeamData?.map((row, idx) => (
//                         <tr key={idx}>
//                           <td className="ps-2">
//                             {convertToINRFormat(row?.BusinessAmount)}
//                           </td>
//                           <td>{convertToINRFormat(row.IncomeAmount)}</td>
//                           <td>{row.IncomeType}</td>
//                           <td>{row.PVPercent}%</td>
//                           <td>{row.PVValue}</td>
//                           <td>
//                             {/* {row.SBCPercent} */}
//                             {parseInt(row.SBCPercent) > 0
//                               ? parseInt(row.SBCPercent)
//                               : parseInt(row.TBCPercent)
//                                 ? parseInt(row.TBCPercent)
//                                 : 0}{" "}
//                             % {row?.IncomeType}
//                           </td>
//                           <td className="ps-2">{row.Rank}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// const PayoutSummaryCards = ({ response }) => {
//   if (!response) return null;
//   const {
//     AssociateName,
//     AssociateCode,
//     Rank,
//     PayoutNo,
//     ClosingDate,
//     TotalSelfBussiness,
//     TotalSelfIncome,
//     TotalTeamBussiness,
//     TotalTeamIncome,
//   } = response;

//   const cardStyle = {
//     backgroundColor: themeColor,
//     color: "#fff",
//     borderRadius: "12px",
//     padding: "16px",
//     // minHeight: "100px",
//   };
//   const labelStyle = { fontWeight: "500", fontSize: "0.95rem" };
//   const valueStyle = {
//     fontWeight: "500",
//     fontSize: "0.9rem",
//     textAlign: "right",
//   };

//   return (
//     <div className=" py-3">
//       <div className="row g-3">
//         {/* Associate Info */}
//         <div className="col-lg-3 col-sm-6">
//           <div className="card shadow border-0" style={cardStyle}>
//             <div className="d-flex justify-content-between align-items-center row-gap-4 my-2">
//               <span style={labelStyle}>Associate :</span>
//               <span style={valueStyle}>{AssociateName}</span>
//             </div>
//             <div className="d-flex justify-content-between align-items-center ">
//               <span style={labelStyle}>Code:</span>
//               <span style={valueStyle}>
//                 {AssociateCode} [{Rank}]
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Payout Info */}
//         <div className="col-lg-3 col-sm-6">
//           <div className="card shadow border-0" style={cardStyle}>
//             <div className="d-flex   justify-content-between align-items-center my-2">
//               <span style={labelStyle}>Payout No :</span>
//               <span style={valueStyle}>{PayoutNo}</span>
//             </div>
//             <div className="d-flex   justify-content-between align-items-center ">
//               <span style={labelStyle}>Closing Date:</span>
//               <span style={valueStyle}>{ClosingDate}</span>
//             </div>
//           </div>
//         </div>

//         {/* Self Business */}
//         <div className="col-lg-3 col-sm-6">
//           <div className="card shadow border-0" style={cardStyle}>
//             <div className="d-flex   justify-content-between align-items-center my-2">
//               <span style={labelStyle}>Self Business:</span>
//               <span style={valueStyle}>₹{TotalSelfBussiness}</span>
//             </div>
//             <div className="d-flex   justify-content-between align-items-center ">
//               <span style={labelStyle}>Self Income:</span>
//               <span style={valueStyle}>₹{TotalSelfIncome}</span>
//             </div>
//           </div>
//         </div>

//         {/* Team Business */}
//         <div className="col-lg-3 col-sm-6">
//           <div className="card shadow border-0" style={cardStyle}>
//             <div className="d-flex   justify-content-between align-items-center my-2">
//               <span style={labelStyle}>Team Business:</span>
//               <span style={valueStyle}>₹{TotalTeamBussiness}</span>
//             </div>
//             <div className="d-flex   justify-content-between align-items-center">
//               <span style={labelStyle}>Team Income:</span>
//               <span style={valueStyle}>₹{TotalTeamIncome}</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // export default PayoutSummaryCards;
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaUserTie, FaWallet, FaChartLine, FaUsers } from "react-icons/fa";

import useApiRequest from "../../../../Hooks/apiReq";
import TitleSection from "../../../../Shared/TitleSection/TitleSection";
import Loader from "../../../../CommonComponets/Loader";
import BackButton from "../../../../Shared/BackButton";
import { convertToINRFormat } from "../../../../Utils/INRConvert";

const MyPayoutDetail = () => {
  const { state } = useLocation();
  const id = state?.payoutNo || "";
  const { loading, sendApiRequest, response: apiResponse } = useApiRequest();
  const navigate = useNavigate();
  const [response, setResponse] = useState({
    AssociateName: "John Doe",
    AssociateCode: "ASSO12345",
    Rank: "Platinum Director",
    PayoutNo: "PAY-2026-001",
    ClosingDate: "31-Jan-2026",
    TotalSelfBussiness: 150000,
    TotalSelfIncome: 12500,
    TotalTeamBussiness: 1200000,
    TotalTeamIncome: 48000,
    AssoSelfBPayoutDetailListData: [
      {
        PaidAmount: 50000,
        AssoName: "John Doe",
        CustomerName: "Alice Smith",
        PaymentDate: "12-Jan-2026",
        DirectPVAmount: 500,
        LevelPVAmount: 200,
        DirectPVPercentage: 10,
        LevelPVPercentage: 5,
        PlotNo: "B-402",
        JSONDetailsSelfData: [
          {
            BusinessAmount: 50000,
            IncomeAmount: 5000,
            IncomeType: "SBC",
            PVPercent: 10,
            PVValue: 500,
            SBCPercent: "10",
            TBCPercent: "0",
            Rank: "Platinum",
          },
        ],
      },
    ],
    AssoTeamBPayoutDetailListData: [
      {
        PaidAmount: 120000,
        AssoName: "Robert Brown",
        CustomerName: "Charlie Davis",
        PaymentDate: "15-Jan-2026",
        DirectPVAmount: 1200,
        LevelPVAmount: 600,
        DirectPVPercentage: 12,
        LevelPVPercentage: 6,
        PlotNo: "A-101",
        JSONDetailsTeamData: [
          {
            BusinessAmount: 120000,
            IncomeAmount: 7200,
            IncomeType: "TBC",
            PVPercent: 12,
            PVValue: 1440,
            SBCPercent: "0",
            TBCPercent: "6",
            Rank: "Gold",
          },
        ],
      },
    ],
  });

  useEffect(() => {
    const getLoaggedInUser = sessionStorage.getItem("loggedInUser");
    if (getLoaggedInUser && id) {
      const userData = { payoutNo: String(id) };
      sendApiRequest(
        "POST",
        "/BusinessArea/GetAssociatePayoutDetail",
        userData,
        "",
        true,
      );
    }
  }, [id]);

  useEffect(() => {
    if (apiResponse) {
      setResponse(apiResponse);
    }
  }, [apiResponse]);

  const handleClick = () => {
    navigate(-1, { replace: true });
  };

  return (
    <div className="content payoutDetail">
      <div className="container-fluid">
        <div className="row g-2 mx-1">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center">
              <TitleSection text="My Payout detail" />
              <BackButton onClick={handleClick} />
            </div>
          </div>
        </div>
        {response && <PayoutSummaryCards response={response} />}
        {response && <PayoutDetails loading={loading} response={response} />}
      </div>
      {loading && <Loader />}
    </div>
  );
};

const Section = ({ title, icon, data, type }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="card shadow border-0 rounded-1 mb-5"
    >
      <div
        className="card-header text-white py-3 d-flex align-items-center gap-2 rounded-top-1"
        style={{ background: "linear-gradient(135deg, #2a4169d9, #425b87c3)" }}
      >
        {icon}
        <h4 className="mb-0 text-white  ">{title}</h4>
      </div>

      <div
        className="card-body p-2 p-md-3"
        style={{ maxHeight: "800px", overflowY: "auto" }}
      >
        {!data || data.length === 0 ? (
          <p className="text-danger text-center fs-6 mb-0 py-3">
            No {type} business payout data available.
          </p>
        ) : (
          data.map((payout, index) => (
            <div
              key={index}
              className="rounded-0 p-0 mb-4 shadow-sm bg-white border"
            >
              <div className="table-responsive">
                <table
                  className="table align-middle text-center mb-0"
                  style={{ minWidth: "900px" }}
                >
                  <thead>
                    {/* Primary Info Row */}
                    <tr className="bg-light fw-semibold text-nowrap small">
                      <th className="text-start ps-3">Business Amount</th>
                      <th>Business Date</th>
                      <th>PV % (Direct/Level)</th>
                      <th>PV Value (Direct/Level)</th>
                      <th>Business By</th>
                      <th>Customer</th>
                      <th>Plot Detail</th>
                    </tr>
                    <tr className="text-primary small border-bottom bg-white">
                      <td className="text-start ps-3 fw-bold">
                        {convertToINRFormat(payout?.PaidAmount)}
                      </td>
                      <td>{payout?.PaymentDate || "---"}</td>
                      <td>
                        {payout?.DirectPVPercentage}% /{" "}
                        {payout?.LevelPVPercentage}%
                      </td>
                      <td>
                        {payout?.DirectPVAmount} / {payout?.LevelPVAmount}
                      </td>
                      <td>{payout?.AssoName}</td>
                      <td>{payout?.CustomerName}</td>
                      <td>{payout?.PlotNo}</td>
                    </tr>
                    {/* Secondary Breakdown Header */}
                    <tr className="bg-light text-nowrap small">
                      <th className="text-start ps-3">Business Amount</th>
                      <th>PV (%)</th>
                      <th>PV (Value)</th>
                      <th>Commission (%)</th>
                      <th>Income Amount</th>
                      <th>Rank</th>
                    </tr>
                  </thead>
                  <tbody className="small">
                    {(type === "self"
                      ? payout?.JSONDetailsSelfData
                      : payout?.JSONDetailsTeamData
                    )?.map((row, idx) => (
                      <tr key={idx} className="border-bottom">
                        <td className="text-start ps-3 fw-bold">
                          {convertToINRFormat(row?.BusinessAmount)}
                        </td>
                        <td>{row?.PVPercent}%</td>
                        <td>{row?.PVValue}</td>
                        <td>
                          {/* Logic to show SBC or TBC based on availability */}
                          {(parseFloat(row.SBCPercent) > 0
                            ? row.SBCPercent
                            : row.TBCPercent) || 0}{" "}
                          % {row.IncomeType}
                        </td>
                        <td className="text-primary fw-bold">
                          {convertToINRFormat(row?.IncomeAmount)}
                        </td>
                        <td>{row?.Rank}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        )}
      </div>
    </motion.div>
  );
};

const PayoutDetails = ({ response, loading }) => {
  if (!response && !loading) return null;
  return (
    <div className="py-4">
      <Section
        title="Self Business Payout Details"
        icon={<FaUserTie size={20} />}
        data={response?.AssoSelfBPayoutDetailListData}
        type="self"
      />
      <Section
        title="Team Business Payout Details"
        icon={<FaUsers size={20} />}
        data={response?.AssoTeamBPayoutDetailListData}
        type="team"
      />
    </div>
  );
};

const PayoutSummaryCards = ({ response }) => {
  const cards = [
    {
      title: "Associate Info",
      bg: "linear-gradient(135deg, #6b11cbf8, #2574fcbd)",
      icon: <FaUserTie size={26} />,
      content: [
        { label: "Associate", value: response.AssociateName },
        {
          label: "Code",
          value: `${response.AssociateCode} [${response.Rank}]`,
        },
      ],
    },
    {
      title: "Payout Details",
      bg: "linear-gradient(135deg, #aa6e51c8, #a23537be)",
      icon: <FaWallet size={26} />,
      content: [
        { label: "Payout No", value: response.PayoutNo },
        { label: "Closing Date", value: response.ClosingDate },
      ],
    },
    {
      title: "Self Business",
      bg: "linear-gradient(135deg, #009281ce, #7cb813c8)",
      icon: <FaChartLine size={26} />,
      content: [
        {
          label: "Business",
          value: convertToINRFormat(response.TotalSelfBussiness),
        },
        {
          label: "Income",
          value: convertToINRFormat(response.TotalSelfIncome),
        },
      ],
    },
    {
      title: "Team Business",
      bg: "linear-gradient(135deg, #ca3d16d5, #cc9320ce)",
      icon: <FaUsers size={26} />,
      content: [
        {
          label: "Business",
          value: convertToINRFormat(response.TotalTeamBussiness),
        },
        {
          label: "Income",
          value: convertToINRFormat(response.TotalTeamIncome),
        },
      ],
    },
  ];

  return (
    <div className="py-3">
      <div className="row g-4">
        {cards.map((card, index) => (
          <div className="col-lg-3 col-sm-6" key={index}>
            <div
              className="card border-0 shadow-lg h-100"
              style={{
                background: card.bg,
                color: "#fff",
                borderRadius: "16px",
                padding: "18px",
                transition: "transform 0.3s ease",
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="fw-semibold fs-5">{card.title}</div>
                <div className="opacity-75">{card.icon}</div>
              </div>
              {card.content.map((item, i) => (
                <div
                  key={i}
                  className="d-flex justify-content-between align-items-center mb-2"
                >
                  <span style={{ fontWeight: 500, fontSize: "0.9rem" }}>
                    {item.label}:
                  </span>
                  <span
                    style={{
                      fontWeight: 600,
                      fontSize: "0.9rem",
                      textAlign: "right",
                    }}
                  >
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyPayoutDetail;
